module.exports = {
  ENTITY_TYPE: {
    COMPANY: 'COMPANY',
    INDIVIDUAL: 'INDIVIDUAL'
  },
  ENTITY_SUB_TYPE: {
    FREELANCER: 'FREELANCER',
    SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
    PARTNERSHIP: 'PARTNERSHIP',
    LIMITED_LIABILITY_COMPANY: 'LIMITED_LIABILITY_COMPANY',
    LIMITED_LIABILITY_PARTNERSHIP: 'LIMITED_LIABILITY_PARTNERSHIP',
    NON_PROFIT: 'NON_PROFIT',
    S_CORPORATION: 'S_CORPORATION',
    C_CORPORATION: 'C_CORPORATION',
    CORPORATION: 'CORPORATION',
    INCORPORATED: 'INCORPORATED',
    PUBLIC_CORPORATION: 'PUBLIC_CORPORATION',
    PRIVATE_LIMITED: 'PRIVATE_LIMITED',
    LIMITED: 'LIMITED'
  },
  ENTITY_IDENTIFICATION_TYPE: {
    INCORPORATION_NUMBER: 'INCORPORATION_NUMBER',
    OTHERS: 'OTHERS'
  },
  ENTITY_STATUS: {
    INITIATED: 'INITIATED',
    REGISTRATION_SUBMITTED: 'REGISTRATION_SUBMITTED',
    UNDER_COMPLIANCE_REVIEW: 'UNDER_COMPLIANCE_REVIEW',
    UNDER_EDD_PROCESS: 'UNDER_EDD_PROCESS',
    APPROVED: 'APPROVED',
    APPROVED_NO_TRADING: 'APPROVED_NO_TRADING',
    REJECTED: 'REJECTED'
  },
  CREATED_BY_IDENTIFIER: {
    TRULY_USER: 'TRULY_USER',
    LIRA_USER: 'LIRA_USER',
    SYSTEM: 'SYSTEM'
  },
  OFAC_status: {
    NA: 'NA',
    PENDING: 'Pending',
    CLEAR: 'Clear',
    FAILED: 'Failed',
    POSITIVE: 'Positive',
    REVIEWING: 'Reviewing'
  },
  ACCOUNT_AGREEMENT_STATUS: {
    PENDING: 'PENDING',
    FAILED: 'FAILED',
    COMPLETED: 'COMPLETED'
  },
  CIP_STATUS: {
    NONE: 'NONE',
    PENDING: 'PENDING',
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    DOCUMENT_CREATED: 'DOCUMENT_CREATED',
    DOCUMENT_CREATION_FAILED: 'DOCUMENT_CREATION_FAILED',
    DOCUMENT_UPLOAD_FAILED: 'DOCUMENT_UPLOAD_FAILED',
    COMPLETED: 'COMPLETED'
  },
  ONBOARDING_STATUS: {
    READY: 'READY',
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
  }
};
